import ContentWrapper from "@/components/Layout/ContentWrapper";
import Administrator from "../views/Administrator";
import DatabaseCleanup from "../views/DatabaseCleanup";
import ServerLogs from "../views/ServerLogs";
import SessionTimeouts from "../views/SessionTimeouts";
import UILanguages from "../views/UILanguages";
import FamilyAccounts from "../views/FamilyAccounts";
import MailTemplates from "../views/MailTemplates";
import AwardTrophy from "../views/AwardTrophy";
import Games from "../views/Games";
import Achievements from "../views/Achievements";
import Tournaments from "../views/Tournaments";
import Trophies from "../views/Trophies";
import Medals from "../views/Medals";
import Firmware from "../views/Firmware.vue";


export default {
  path: "/",
  component: ContentWrapper,
  children: [
    // {
    //   path: "/",
    //   name: "home",
    //   component: Home,
    //   meta: { requiredAuth: true }
    // },
    {
      path: "",
      name: "administrator",
      component: Administrator,
      meta: { requiredAuth: true }
    },
    {
      path: "/database-cleanup",
      name: "databaseCleanup",
      component: DatabaseCleanup,
      meta: { requiredAuth: true }
    },
    {
      path: "/server-logs",
      name: "serverLogs",
      component: ServerLogs,
      meta: { requiredAuth: true }
    },
    {
      path: "/session-timeouts",
      name: "sessionTimeouts",
      component: SessionTimeouts,
      meta: { requiredAuth: true }
    },
    {
      path: "/ui-languages",
      name: "UILanguages",
      component: UILanguages,
      meta: { requiredAuth: true }
    },
    {
      path: "/family-accounts",
      name: "familyAccounts",
      component: FamilyAccounts,
      meta: { requiredAuth: true }
    },
    {
      path: "/games",
      name: "games",
      component: Games,
      meta: { requiredAuth: true }
    },
    {
      path: "/message-templates",
      name: "mailTemplates",
      component: MailTemplates,
      meta: { requiredAuth: true }
    },
    {
      path: "/award-trophy",
      name: "awardTrophy",
      component: AwardTrophy,
      meta: { requiredAuth: true }
    },
    {
      path: "/achievements",
      name: "achievements",
      component: Achievements,
      meta: { requiredAuth: true }
    },
    {
      path: "/tournaments",
      name: "tournaments",
      component: Tournaments,
      meta: { requiredAuth: true }
    },
    {
      path: "/trophies",
      name: "trophies",
      component: Trophies,
      meta: { requiredAuth: true }
    },
    {
      path: "/medals",
      name: "medals",
      component: Medals,
      meta: { requiredAuth: true }
    },
    {
      path: "/firmware",
      name: "firmware",
      component: Firmware,
      meta: { requiredAuth: true }
    }
  ]
};
